import { useState, useRef, useCallback } from 'react';

interface SpamGuardResult {
  isPending: boolean;
  isInternalPending: boolean;
  execute: <T>(fn: () => Promise<T>) => Promise<ExecuteResult<T>>;
}

type ExecuteResult<T> = { wasSkipped: true; value: undefined } | { wasSkipped: false; value: T };

export const useSpamGuard = (...externalPending: boolean[]): SpamGuardResult => {
  const [isInFlight, setIsInFlight] = useState(false);
  const isInFlightRef = useRef(false);
  const isInternalPending = isInFlight;
  const isPending = isInFlight || externalPending.some(Boolean);

  const execute = useCallback(async <T>(fn: () => Promise<T>): Promise<ExecuteResult<T>> => {
    if (isInFlightRef.current) return { wasSkipped: true, value: undefined };

    isInFlightRef.current = true;
    setIsInFlight(true);

    try {
      const value = await fn();
      return { wasSkipped: false, value };
    } finally {
      isInFlightRef.current = false;
      setIsInFlight(false);
    }
  }, []);

  return { isPending, isInternalPending, execute };
};
